import { render, staticRenderFns } from "./OmniCardFooter.vue?vue&type=template&id=7e100d16&"
import script from "./OmniCardFooter.vue?vue&type=script&lang=js&"
export * from "./OmniCardFooter.vue?vue&type=script&lang=js&"
import style0 from "./OmniCardFooter.vue?vue&type=style&index=0&id=7e100d16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports